const translations = {
    addChemical: 'Add Chemical',
    cancel: 'Cancel',
    chemicalsCount: 'Chemicals',
    copySuffix: '(Copy)',
    crop: 'Crop',
    duplicate: 'Duplicate',
    edit: 'Edit',
    save: 'Save',
    saveAsNew: 'Save as New',
    searchButton: 'Search',
    searchPlaceholder: 'Search chemicals to add...',
    targetPest: 'Target Pest'
};

export default translations;
